export default __webpack_public_path__ + "static/media/LAS0130.34I-30459_-17559_0.075844c2.jpg";